import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgUnsatisfiedEmojiSecondary from './svgs/UnsatisfiedEmojiSecondary.js';
import SvgUnsatisfiedEmoji from './svgs/UnsatisfiedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var unsatisfiedEmoji = (props => useIcon(SvgUnsatisfiedEmoji, SvgUnsatisfiedEmojiSecondary, props));

export { unsatisfiedEmoji as default };
